<template>
  <button @click="$emit('toggle')" class="audio-control-toggler">
    <img class="audio-control-toggler__icon audio-control-toggler__icon--off" v-show="audioIsMuted" src="@/assets/img/audio-off.svg">
    <img class="audio-control-toggler__icon audio-control-toggler__icon--on" v-show="!audioIsMuted" src="@/assets/img/audio-on.svg">
  </button>
</template>

<script>
export default {
  name: 'AudioControl',
  props: {
    audioIsMuted: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>

</style>